module.exports = __webpack_public_path__ + "img/icon-heart-plus.602c1fea.svg";